var v1="<span ng-if=\"editMode\" class=\"column-input\"><span gnp-custom-select=\"\" ng-model=\"score.fairway\" disable=\"!isShotEntered(score) || !allowEnterFairwayHit(score)\" options=\"defaultData.fairwayOptions\" class=\"input gray\"></span></span>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("score-card/templates/fairway.jade", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ngapp/javascript/web/components/score-card/templates/fairway.jade
// module id = 401
// module chunks = 0